"use client";

import { c as _c } from "react/compiler-runtime";
import { IconX } from "@tabler/icons-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
export interface PlpFilterPill {
  id: string;
  label: string;
  onRemove: () => void;
}
export interface SearchPill {
  label: string;
  onClear: () => void;
}
interface Props {
  pills: PlpFilterPill[];
  searchPill?: SearchPill;
  onClearAll?: () => void;
}
export function PlpFilterPillBar(t0) {
  const $ = _c(10);
  const {
    pills,
    searchPill,
    onClearAll
  } = t0;
  const hasActive = pills.length > 0 || searchPill !== undefined;
  if (!hasActive) {
    return null;
  }
  let t1;
  if ($[0] !== searchPill) {
    t1 = searchPill && <Badge variant="secondary" className="cursor-pointer gap-1 px-2 py-0.5 text-xs bg-input rounded-md" data-testid="plp-filter-pill-search" asChild={true}><button type="button" onClick={searchPill.onClear} aria-label={`Clear ${searchPill.label}`}>{searchPill.label}<IconX className="size-3.5" aria-hidden={true} /></button></Badge>;
    $[0] = searchPill;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== pills) {
    t2 = pills.map(_temp);
    $[2] = pills;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onClearAll) {
    t3 = onClearAll && <Button type="button" variant="ghost" size="sm" onClick={onClearAll} className="h-auto px-1 py-0.5 text-xs font-medium text-destructive hover:text-destructive">Clear All</Button>;
    $[4] = onClearAll;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex flex-wrap items-center gap-3" data-testid="plp-filter-pill-bar">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp(pill) {
  return <Badge key={pill.id} variant="secondary" className="cursor-pointer gap-1 px-2 py-0.5 text-xs bg-input rounded-md" data-testid={`plp-filter-pill-${pill.id}`} asChild={true}><button type="button" onClick={pill.onRemove} aria-label={`Remove ${pill.label}`}>{pill.label}<IconX className="size-3.5" aria-hidden={true} /></button></Badge>;
}